// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Edjin's homepage (EdjinHome.jsx), in the HOTmaths homepage's type and spacing; colours from the .edjin theme. */

.hero__EdjinHome-module--W0Elf {
    padding: var(--space-3xl) var(--space-md);
    background-color: var(--color-surface-inverse);
    background-image: linear-gradient(rgb(10 30 45 / 0.72), rgb(10 30 45 / 0.72)), var(--edjin-hero-image);
    background-size: cover;
    background-position: center;
    color: #FFFFFF;
}

.heroInner__EdjinHome-module--AHh7g {
    max-width: 1200px;
    min-height: min(60vh, 560px);
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: var(--space-lg);
}

.heroHeading__EdjinHome-module--njKET {
    margin: 0;
    max-width: 14ch;
    font-size: var(--home-text-heading-lg);
    font-weight: 800;
    letter-spacing: -0.03em;
    line-height: 0.98;
    text-wrap: balance;
    color: #FFFFFF;
}

.heroStandfirst__EdjinHome-module--RZNXs {
    margin: 0;
    max-width: 560px;
    font-size: clamp(18px, 1.6vw, 22px);
    line-height: 1.55;
}

.heroActions__EdjinHome-module--EcThX {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-sm);
}

.section__EdjinHome-module--tLfJ2 {
    padding: var(--space-3xl) var(--space-md);
}

.tinted__EdjinHome-module--g1iiT {
    background: var(--color-surface-secondary);
}

.inner__EdjinHome-module--FKP1G {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: var(--space-lg);
}

.heading__EdjinHome-module--GMjcY {
    margin: 0;
    font-size: var(--home-text-heading);
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1;
    text-wrap: balance;
}

.standfirst__EdjinHome-module--JfUeV {
    margin: 0;
    max-width: 60ch;
    font-size: 18px;
    line-height: 1.6;
    color: var(--color-text-secondary);
}

/* Doubled class, like Layout's .nav.nav: styles.css styles bare lists more specifically than one class. */
.cards__EdjinHome-module--NQaJh.cards__EdjinHome-module--NQaJh,
.products__EdjinHome-module--u9X_k.products__EdjinHome-module--u9X_k {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(300px, 100%), 1fr));
    gap: var(--space-md);
    margin: 0;
    padding: 0;
    list-style: none;
}

.cards__EdjinHome-module--NQaJh.cards__EdjinHome-module--NQaJh > li,
.products__EdjinHome-module--u9X_k.products__EdjinHome-module--u9X_k > li {
    margin: 0;
    min-width: 0;
}

.card__EdjinHome-module--dguax {
    display: flex;
    flex-direction: column;
    gap: var(--space-xs);
    padding: var(--space-lg);
    border-radius: var(--home-radius-2xl);
    background: var(--color-surface-raised, var(--color-surface-base));
    border: 1px solid var(--color-border-default);
}

.featureImage__EdjinHome-module--yM2QX {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    object-fit: cover;
    margin-bottom: var(--space-xs);
}

.awardImage__EdjinHome-module--sP7t0 {
    height: 96px;
    width: auto;
    max-width: 100%;
    object-fit: contain;
    align-self: flex-start;
    margin-bottom: var(--space-xs);
}

.cardTitle__EdjinHome-module--F_fpA {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.3;
}

.cardBody__EdjinHome-module--iPgQO {
    margin: 0;
    font-size: 16px;
    line-height: 1.6;
    color: var(--color-text-secondary);
}

.product__EdjinHome-module--k8vDB {
    display: flex;
    flex-direction: column;
    height: 100%;
    border-radius: var(--home-radius-2xl);
    overflow: hidden;
    background: var(--color-surface-base);
    color: var(--color-text-primary);
    text-decoration: none;
}

a.product__EdjinHome-module--k8vDB:hover .productName__EdjinHome-module--Rqhqp {
    text-decoration: underline;
}

a.product__EdjinHome-module--k8vDB:focus-visible {
    outline: 2px solid var(--color-focus-outline);
    outline-offset: var(--focus-outline-offset);
}

.productImage__EdjinHome-module--nan8x {
    display: block;
    width: 100%;
    aspect-ratio: 16 / 10;
    object-fit: cover;
}

.productName__EdjinHome-module--Rqhqp {
    padding: var(--space-sm) var(--space-md);
    font-size: 17px;
    font-weight: 700;
}

.contact__EdjinHome-module--UCLyQ {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(420px, 100%), 1fr));
    gap: var(--space-2xl);
    align-items: start;
}

.contactIntro__EdjinHome-module--dKkQR {
    display: flex;
    flex-direction: column;
    gap: var(--space-md);
    min-width: 0;
}

.contactCard__EdjinHome-module--R156S {
    min-width: 0;
    padding: var(--space-lg);
    border-radius: var(--home-radius-3xl);
    background: var(--color-surface-secondary);
}

.alert__EdjinHome-module--TORAb {
    margin-bottom: var(--space-md);
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/EdjinHome.module.css"],"names":[],"mappings":"AAAA,kHAAkH;;AAElH;IACI,yCAAyC;IACzC,8CAA8C;IAC9C,sGAAsG;IACtG,sBAAsB;IACtB,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,sCAAsC;IACtC,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,mCAAmC;IACnC,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,mCAAmC;IACnC,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA,0GAA0G;AAC1G;;IAEI,aAAa;IACb,sEAAsE;IACtE,oBAAoB;IACpB,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;;IAEI,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,wBAAwB;IACxB,qCAAqC;IACrC,kEAAkE;IAClE,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,qCAAqC;IACrC,gBAAgB;IAChB,qCAAqC;IACrC,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6CAA6C;IAC7C,2CAA2C;AAC/C;;AAEA;IACI,cAAc;IACd,WAAW;IACX,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sEAAsE;IACtE,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,qCAAqC;IACrC,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":["/* Edjin's homepage (EdjinHome.jsx), in the HOTmaths homepage's type and spacing; colours from the .edjin theme. */\n\n.hero {\n    padding: var(--space-3xl) var(--space-md);\n    background-color: var(--color-surface-inverse);\n    background-image: linear-gradient(rgb(10 30 45 / 0.72), rgb(10 30 45 / 0.72)), var(--edjin-hero-image);\n    background-size: cover;\n    background-position: center;\n    color: #FFFFFF;\n}\n\n.heroInner {\n    max-width: 1200px;\n    min-height: min(60vh, 560px);\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: var(--space-lg);\n}\n\n.heroHeading {\n    margin: 0;\n    max-width: 14ch;\n    font-size: var(--home-text-heading-lg);\n    font-weight: 800;\n    letter-spacing: -0.03em;\n    line-height: 0.98;\n    text-wrap: balance;\n    color: #FFFFFF;\n}\n\n.heroStandfirst {\n    margin: 0;\n    max-width: 560px;\n    font-size: clamp(18px, 1.6vw, 22px);\n    line-height: 1.55;\n}\n\n.heroActions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: var(--space-sm);\n}\n\n.section {\n    padding: var(--space-3xl) var(--space-md);\n}\n\n.tinted {\n    background: var(--color-surface-secondary);\n}\n\n.inner {\n    max-width: 1200px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-lg);\n}\n\n.heading {\n    margin: 0;\n    font-size: var(--home-text-heading);\n    font-weight: 800;\n    letter-spacing: -0.02em;\n    line-height: 1;\n    text-wrap: balance;\n}\n\n.standfirst {\n    margin: 0;\n    max-width: 60ch;\n    font-size: 18px;\n    line-height: 1.6;\n    color: var(--color-text-secondary);\n}\n\n/* Doubled class, like Layout's .nav.nav: styles.css styles bare lists more specifically than one class. */\n.cards.cards,\n.products.products {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(min(300px, 100%), 1fr));\n    gap: var(--space-md);\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n\n.cards.cards > li,\n.products.products > li {\n    margin: 0;\n    min-width: 0;\n}\n\n.card {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-xs);\n    padding: var(--space-lg);\n    border-radius: var(--home-radius-2xl);\n    background: var(--color-surface-raised, var(--color-surface-base));\n    border: 1px solid var(--color-border-default);\n}\n\n.featureImage {\n    width: 96px;\n    height: 96px;\n    border-radius: 50%;\n    object-fit: cover;\n    margin-bottom: var(--space-xs);\n}\n\n.awardImage {\n    height: 96px;\n    width: auto;\n    max-width: 100%;\n    object-fit: contain;\n    align-self: flex-start;\n    margin-bottom: var(--space-xs);\n}\n\n.cardTitle {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 1.3;\n}\n\n.cardBody {\n    margin: 0;\n    font-size: 16px;\n    line-height: 1.6;\n    color: var(--color-text-secondary);\n}\n\n.product {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    border-radius: var(--home-radius-2xl);\n    overflow: hidden;\n    background: var(--color-surface-base);\n    color: var(--color-text-primary);\n    text-decoration: none;\n}\n\na.product:hover .productName {\n    text-decoration: underline;\n}\n\na.product:focus-visible {\n    outline: 2px solid var(--color-focus-outline);\n    outline-offset: var(--focus-outline-offset);\n}\n\n.productImage {\n    display: block;\n    width: 100%;\n    aspect-ratio: 16 / 10;\n    object-fit: cover;\n}\n\n.productName {\n    padding: var(--space-sm) var(--space-md);\n    font-size: 17px;\n    font-weight: 700;\n}\n\n.contact {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(min(420px, 100%), 1fr));\n    gap: var(--space-2xl);\n    align-items: start;\n}\n\n.contactIntro {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-md);\n    min-width: 0;\n}\n\n.contactCard {\n    min-width: 0;\n    padding: var(--space-lg);\n    border-radius: var(--home-radius-3xl);\n    background: var(--color-surface-secondary);\n}\n\n.alert {\n    margin-bottom: var(--space-md);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hero": `hero__EdjinHome-module--W0Elf`,
	"heroInner": `heroInner__EdjinHome-module--AHh7g`,
	"heroHeading": `heroHeading__EdjinHome-module--njKET`,
	"heroStandfirst": `heroStandfirst__EdjinHome-module--RZNXs`,
	"heroActions": `heroActions__EdjinHome-module--EcThX`,
	"section": `section__EdjinHome-module--tLfJ2`,
	"tinted": `tinted__EdjinHome-module--g1iiT`,
	"inner": `inner__EdjinHome-module--FKP1G`,
	"heading": `heading__EdjinHome-module--GMjcY`,
	"standfirst": `standfirst__EdjinHome-module--JfUeV`,
	"cards": `cards__EdjinHome-module--NQaJh`,
	"products": `products__EdjinHome-module--u9X_k`,
	"card": `card__EdjinHome-module--dguax`,
	"featureImage": `featureImage__EdjinHome-module--yM2QX`,
	"awardImage": `awardImage__EdjinHome-module--sP7t0`,
	"cardTitle": `cardTitle__EdjinHome-module--F_fpA`,
	"cardBody": `cardBody__EdjinHome-module--iPgQO`,
	"product": `product__EdjinHome-module--k8vDB`,
	"productName": `productName__EdjinHome-module--Rqhqp`,
	"productImage": `productImage__EdjinHome-module--nan8x`,
	"contact": `contact__EdjinHome-module--UCLyQ`,
	"contactIntro": `contactIntro__EdjinHome-module--dKkQR`,
	"contactCard": `contactCard__EdjinHome-module--R156S`,
	"alert": `alert__EdjinHome-module--TORAb`
};
export default ___CSS_LOADER_EXPORT___;
